import { useState } from "react";
import { useTranslation } from "next-i18next";
import ClipLoader from "react-spinners/ClipLoader";
import styles from "./Autocomplete.module.scss";
import translate_word from "../../utils/translate";

function Autocomplete(props) {
    const { t } = useTranslation();
    // const translate = useSelector(state => state.translate);
    const [open, setOpen] = useState(false);
    return (
        <div>
            {open ? <div className={styles.aria_hidden}
                onClick={() => setOpen(false)}></div> : null}
            <div className={styles.autocomplete}>
                {!props.outlined ? <span className={!open ? styles.label : styles.label_active}>{props.label}</span> : null}
                <div className={!props.outlined ? styles.input_cont : styles.input_outlined_cont}>
                    <input
                        placeholder={props.placeholder}
                        className={styles.input}
                        value={props.value ? props.value : props.selected}
                        onFocus={() => setOpen(true)}
                        onChange={(e) => {
                            props.onChange(e.target.value);
                        }} />
                    <div className="autocomplete-icon">
                        <span
                            className='icon-cross'
                            onClick={() => {
                                if (props.value) {
                                    props.onChange();
                                } else {
                                    props.onSelect();
                                }
                            }}></span>
                    </div>
                    <img src="/drop-down-arrow.png"
                        className={styles.drop_down_arrow}
                        onClick={() => {
                            setOpen(!open);
                        }}></img>
                </div>
                {open ? <div className={styles.list_cont}>
                    {!props.loading ? props.list.map((item, index) => {
                        return <div
                            className={styles.list_item}
                            onClick={() => {
                                props.onSelect(item);
                                props.onChange();
                                setOpen(false);
                            }}
                            key={index}>
                            {translate_word(item, props.language)}
                            , {translate_word(item.departement_details, props.language)}
                        </div>;
                    }) : <div className="w-100 d-flex justify-content-center">
                        <ClipLoader color="#464646" size={15} />
                    </div>
                    }
                </div> : null}
            </div>
        </div>
    );
}
export default Autocomplete;